import styled from 'styled-components';
import { SideNavColorSchemeProps, SideNavColorSchemeIndex } from '../..';
import { localTheme } from '../../../../styles/local-theme';

interface StyledSubCategoryItemProps extends SideNavColorSchemeProps {
  isActive?: boolean;
  isDragging?: boolean;
  isDraggable?: boolean;
}

const bgColorSchemes: SideNavColorSchemeIndex = {
  dark: localTheme.colors.pureBlack,
  blue: localTheme.colors.darkBlue,
};
const textColorSchemes: SideNavColorSchemeIndex = {
  dark: localTheme.colors.iceGray,
  blue: localTheme.colors.paleBlue,
};

const draggingStyle = (props): string => `
  padding: ${props.theme.spaces.md};
  background-color: ${bgColorSchemes[props.colorScheme]};
  box-shadow: 0px 0.1rem 0.4rem rgba(0, 0, 0, 0.5);
  font-weight: ${props.theme.fontWeight.medium};
  border: solid 0.1rem ${props.theme.colors.lightBlue};
  border-radius: ${props.theme.borderRadius.light};
`;

const SubCategoryItem = styled.div<StyledSubCategoryItemProps>`
  display: block;
  cursor: pointer;
  border-radius: ${(props): string => props.theme.borderRadius.light};

  color: ${(props): string => textColorSchemes[props.colorScheme]};
  padding: ${(props): string =>
    `${props.theme.spaces.md} ${
      props.isActive ? props.theme.spaces.md : '0px'
    }`};

  background-color: ${(props): string =>
    props.isActive ? bgColorSchemes[props.colorScheme] : 'unset'};

  margin: 0 -${(props): string => (props.isActive ? props.theme.spaces.md : '0px')};
  font-weight: ${(props): string =>
    props.isActive ? `${props.theme.fontWeight.medium}` : 'normal'};

  ${(props): string => (props.isDragging ? draggingStyle(props) : '')}

  &:hover {
    cursor: ${(props): string => (props.isDraggable ? 'move' : 'pointer')};
    padding: ${(props): string => props.theme.spaces.md};
    background-color: ${(props): string => bgColorSchemes[props.colorScheme]};
    margin: 0 -${(props): string => props.theme.spaces.md};
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.5);
    font-weight: ${(props): number => props.theme.fontWeight.medium};

    // this bottom margin ensure there is a margin when drag this item into dropable area
    margin-bottom: ${(props): string => props.theme.spaces.lg};
    & + * {
      // decrease the margin of next element with the same value to ensure no change on UI
      margin-top: -${(props): string => props.theme.spaces.lg};
    }
  }
`;

export { SubCategoryItem };
